import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'audio-player-dsgn',
    mixins: [BaseComponent],
    data: function () {
        return {
        }
    },
    props: {
        type: null,
    },
    render() {
        let name;
        if (!this.Name)
            name = this.type || 'Unnamed';
        else
            name = this.Name + ': ' + this.type || 'Unnamed';

        const style = {
            border: '1px solid #ddd',
            margin: '3px',
            padding: '8px 5px',
            borderRadius: '8px',
            backgroundColor: 'yellow',
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
        };

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={style}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {name}<br />
            </div>
        );
    }
});